import React from 'react'
import { CardActionArea, makeStyles, Fade, Box } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'
import { alpha } from '@material-ui/core/styles/colorManipulator'
import PropTypes from 'prop-types'
import TopSection from 'components/JarCard/TopSection'

const useStyles = makeStyles((theme) => ({
  checkMark: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1
  },
  scrim: {
    backgroundColor: alpha(theme.palette.secondary.main, 0.24)
  }
}))

export default function SelectableTopSection({ onSelect, onDeselect, selected, id }) {
  const classes = useStyles()

  function handleToggleSelect() {
    selected ? onDeselect() : onSelect()    
  }

  return (
    <CardActionArea onClick={handleToggleSelect}>
      <Fade in={selected}>
        <CheckCircle fontSize='large' color='secondary' className={classes.checkMark} />
      </Fade>
      {selected && (
        <Box position='absolute' top='0' left='0' width='100%' height='100%' className={classes.scrim} />
      )}
      <TopSection id={id} />
    </CardActionArea>
  )
}

SelectableTopSection.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onDeselect: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired
}
